import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

declare let gtag: Function;

export interface GA4EventParams {
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class GA4Service {
  private readonly GA4_MEASUREMENT_ID = 'G-22MW84C2QL';

  constructor(private authService: AuthService) {}


  private isGA4Available(): boolean {
    return typeof gtag !== 'undefined';
  }

  private isAdminUser(): boolean {
    const user = this.authService.getCurrentUser();

    const userType = (user as any)?.userType;
    if (!userType) {
      return false;
    }

    return String(userType).toLowerCase() === 'adm';
  }

  trackEvent(eventName: string, params: GA4EventParams = {}): void {
    if (this.isAdminUser()) {
      return;
    }

    if (!this.isGA4Available()) {
      console.warn('GA4 não está disponível. Evento não enviado:', eventName, params);
      return;
    }
    

    const finalParams: GA4EventParams = {};
    for (const key in params) {
      if (params.hasOwnProperty(key) && params[key] !== undefined && params[key] !== null) {
        finalParams[key] = params[key];
      }
    }

    try {
      gtag('event', eventName, finalParams);
    } catch (error) {
      console.error('Erro ao enviar evento para GA4:', error);
    }
  }

  trackScreenView(screenName: string, featureName: string, additionalParams: GA4EventParams = {}): void {
    const params: GA4EventParams = {
      screen_name: screenName,
      feature_name: featureName,
      ...additionalParams
    };

    this.trackEvent('screen_view', params);
  }

  trackApiError(api: string, errorCode: string | number, screenName: string, featureName: string): void {
    const params: GA4EventParams = {
      api,
      error_code: String(errorCode),
      screen_name: screenName,
      feature_name: featureName,
      has_error: true
    };
    
    this.trackEvent('api_error', params);
  }

  trackFormError(field: string, screenName: string, featureName: string, errorType?: string): void {
    const params: GA4EventParams = {
      field,
      error_type: errorType,
      screen_name: screenName,
      feature_name: featureName,
      has_error: true
    };
    
    this.trackEvent('form_error', params);
  }

  trackUserAccess(): void {
    if (this.isAdminUser()) {
      return;
    }

    if (!this.isGA4Available()) {
      console.warn('GA4 não está disponível. Acesso do usuário não registrado.');
      return;
    }

    const contract = this.authService.getCurrentContract();

    if (!contract || !contract.id) {
      console.warn('GA4: Contrato não encontrado. Acesso não registrado.');
      return;
    }

    try {
      const user = this.authService.getCurrentUser();
      
      if (user?.id) {
        gtag('config', this.GA4_MEASUREMENT_ID, {
          user_id: String(user.id)
        });
      }

      const userParams: GA4EventParams = {
        app_module_group: 'Falcon',
        app_module: 'falcon',
        contract_id: contract.id,
        contract_name: contract.name,
      };
      
      if (user?.email) {
        userParams['user_email'] = user.email;
      }
      
      if (user?.id) {
        userParams['app_user_id'] = String(user.id);
      }

      gtag('set', 'user_properties', {
        contract_id: contract.id,
        contract_name: contract.name,
        app_module: 'falcon'
      });

      gtag('event', 'user_access', userParams);
    } catch (error) {
      console.error('Erro ao registrar acesso do usuário no GA4:', error);
    }
  }


   // Rastreia usuários ativos por tela

  trackActiveUserByScreen(screenName: string, featureName: string): void {
    if(this.isAdminUser()) {
      return;
    }
    if (!this.isGA4Available()) {
      console.warn('GA4 não está disponível. Rastreamento de tela não registrado.');
      return;
    }

    const contract = this.authService.getCurrentContract();

    if (!contract || !contract.id) {
      console.warn('GA4: Contrato não encontrado. Rastreamento de tela não registrado.');
      return;
    }

    try {
      const user = this.authService.getCurrentUser();

      const params: GA4EventParams = {
        screen_name: screenName,
        feature_name: featureName,
        contract_id: contract.id,
        contract_name: contract.name,
        app_module: 'falcon'
      };

      if (user?.id) {
        params['user_id'] = String(user.id);
      }

      this.trackEvent('active_user_by_screen', params);
    } catch (error) {
      console.error('Erro ao registrar usuário ativo por tela no GA4:', error);
    }
  }
}

